import React from "react"

const Headers = {
  h1: props => {
    return <h1 className="text-xl md:text-3xl font-bold">{props.children}</h1>
  },
}

export default Headers
